import React from "react";

const ExpenseSorting = ({ sortBy, sortOrder, handleSort }) => {
  return (
    <thead className="mb-3">
      <tr className=" ms-4 search-tableHead shadow">
        <th className="Table-head hide-sm-screen">#</th>
        <th onClick={() => handleSort("date")}>
          <span className=" verticalAlign">Date</span>
          {sortBy === "date" &&
            (sortOrder === "asc" ? (
              <span className="material-symbols-outlined verticalAlign">
                arrow_upward
              </span>
            ) : (
              <span className="material-symbols-outlined verticalAlign">
                arrow_downward
              </span>
            ))}
        </th>
        <th onClick={() => handleSort("item")}>
          <span className=" verticalAlign">Item</span>
          {sortBy === "item" &&
            (sortOrder === "asc" ? (
              <span className="material-symbols-outlined verticalAlign">
                arrow_upward
              </span>
            ) : (
              <span className="material-symbols-outlined verticalAlign">
                arrow_downward
              </span>
            ))}
        </th>
        <th className="hide-sm-screen" onClick={() => handleSort("category")}>
          <span className=" verticalAlign">Category</span>
          {sortBy === "category" &&
            (sortOrder === "asc" ? (
              <span className="material-symbols-outlined verticalAlign">
                arrow_upward
              </span>
            ) : (
              <span className="material-symbols-outlined verticalAlign">
                arrow_downward
              </span>
            ))}
        </th>
        <th
          className=" text-center hide-sm-screen"
          onClick={() => handleSort("quantity")}
        >
          <span className=" verticalAlign">Quantity</span>
          {sortBy === "quantity" &&
            (sortOrder === "asc" ? (
              <span className="material-symbols-outlined verticalAlign">
                arrow_upward
              </span>
            ) : (
              <span className="material-symbols-outlined verticalAlign">
                arrow_downward
              </span>
            ))}
        </th>
        <th className="text-end" onClick={() => handleSort("amount")}>
          <span className=" verticalAlign">Amount</span>
          {sortBy === "amount" &&
            (sortOrder === "asc" ? (
              <span className="material-symbols-outlined verticalAlign">
                arrow_upward
              </span>
            ) : (
              <span className="material-symbols-outlined verticalAlign">
                arrow_downward
              </span>
            ))}
        </th>
        <th className="text-center">Action</th>
      </tr>
    </thead>
  );
};

export default ExpenseSorting;
